import {RouteProps} from 'config/navigation';
import {MdCreditCard} from 'react-icons/md';

import Billings from './billings';
import BillingDetails from './billing-details';

const billingsPages: RouteProps = {
  name: 'Faturas',
  path: 'billings',
  permission: 'billings.findAll',
  icon: <MdCreditCard />,
  subRoutes: [
    {
      path: '',
      element: <Billings />,
      permissions: ['billings.findAll'],
    },
    {
      path: ':id',
      element: <BillingDetails />,
      permissions: ['billings.findOne'],
      wrapper: false,
      hideDrawer: true,
    },
  ],
};

export default billingsPages;
